document.addEventListener('DOMContentLoaded', () => {
  class StoreListManager {
    constructor() {
      this.mainPage = document.querySelector('#MainContent');
      this.expandButtonClass = 'js-store-expand';
      this.resultListSelector = '.stockist-result-list';
      this.mapSelector = '.stockist-map';
      this.isClicked = false;

      this.init();
    }

    init() {
      if (!this.mainPage) return;
      this.removeExistingButton();
      this.setupObserver();
      this.setupResizeListener();
    }

    removeExistingButton() {
      const existingButton = document.querySelector(
        `.${this.expandButtonClass}`,
      );
      if (existingButton) existingButton.remove();
    }

    setupObserver() {
      const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
          if (mutation.type === 'childList') this.initializeStoreListButton();
        }
      });
      observer.observe(this.mainPage, { childList: true, subtree: true });
    }

    setupResizeListener() {
      window.addEventListener('resize', () => {
        this.removeExistingButton();

        setTimeout(() => {
          this.initializeStoreListButton();
        }, 10);
      });
    }

    initializeStoreListButton() {
      const resultList = document.querySelector(this.resultListSelector);
      const stockistMap = document.querySelector(this.mapSelector);

      if (!resultList || window.innerWidth > 767) return;

      const totalListItems = resultList.querySelectorAll('ul li').length;
      let expandButton = document.querySelector(`.${this.expandButtonClass}`);

      if (expandButton) {
        expandButton.classList.toggle('hidden', totalListItems <= 5);
      } else if (totalListItems > 5) {
        expandButton = this.createExpandButton();
        resultList.parentNode.insertBefore(
          expandButton,
          resultList.nextSibling,
        );
        this.setupExpandButton(expandButton, resultList);
      }

      resultList.addEventListener('click', () => {
        if (this.isClicked) return;

        this.isClicked = true;
        stockistMap.scrollIntoView({ behavior: 'smooth' });

        setTimeout(() => {
          this.isClicked = false;
        }, 500);
      });
    }

    createExpandButton() {
      const button = document.createElement('button');
      button.classList.add(
        'stockist-button',
        this.expandButtonClass,
        'button',
        'button-solid',
      );
      button.innerHTML = `
        <span class="stockist-button-text">Show all stores</span>
        <span class="stockist-button-text">Hide stores</span>
      `;
      return button;
    }

    setupExpandButton(button, resultList) {
      button.addEventListener('click', () => {
        resultList.classList.toggle('expanded');
        if (!resultList.classList.contains('expanded')) {
          resultList.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }

  new StoreListManager();
});
